import(/* webpackMode: "eager" */ "/var/www/businessstorepro/app/src/app/(default)/success/page.tsx");
